import { combineReducers } from 'redux'
import contentForms from './contentForms'
import currentForm from './currentForm'
import selectedUserId from './selectedUserId'
import loadingFormAnswers from './loadingFormAnswers'
import answerStatusStatistics from './answerStatusStatistics'
import answerInProgress from './answerInProgress'
import contentFormsLoadingState from './contentFormsLoadingState'
import displayAnswersMode from './displayAnswersMode'
import attachDetachProcessingFormId from './attachDetachProcessingFormId'
import formExportInProgress from './formExportInProgress'
import lastAttachedForm from './lastAttachedForm'
import isSwitchFormDialogOpen from './isSwitchFormDialogOpen'
import infoMessageCondition from './infoMessageCondition'
import answerStatusFilter from './answerStatusFilter'
import recordSavingInProgress from './recordSavingInProgress'
import currentFolder from './currentFolder'
import usersFilter from './usersFilter'

export default combineReducers({
  contentForms,
  currentForm,
  selectedUserId,
  loadingFormAnswers,
  answerStatusStatistics,
  answerInProgress,
  contentFormsLoadingState,
  displayAnswersMode,
  attachDetachProcessingFormId,
  formExportInProgress,
  lastAttachedForm,
  isSwitchFormDialogOpen,
  infoMessageCondition,
  answerStatusFilter,
  recordSavingInProgress,
  currentFolder,
  usersFilter,
})
